export default "__VITE_ASSET__xg1Tl_q4__"